export default function NettoyageHero() {
  return (
    <section className="relative min-h-[680px] flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=professional%20cleaning%20team%20in%20white%20uniform%20cleaning%20a%20bright%20modern%20luxury%20apartment%20Geneva%20Switzerland%20sparkling%20clean%20surfaces%20polished%20floors%20gleaming%20windows%20natural%20light%20warm%20atmosphere%20pristine%20interior%20eco-friendly%20products&width=1920&height=700&seq=nettoyage-hero-v2-01&orientation=landscape"
          alt="Service de nettoyage professionnel à Genève"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-stone-900/85 via-stone-900/60 to-stone-900/30"></div>
      </div>

      <div className="relative z-10 w-full mx-auto max-w-7xl px-6 lg:px-8 py-28">
        <div className="max-w-2xl">
          {/* Badge */}
          <div className="flex items-center gap-3 mb-6">
            <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-emerald-500/20 border border-emerald-400/40">
              <i className="ri-service-line text-emerald-400 text-sm"></i>
            </div>
            <span className="text-xs font-bold tracking-widest uppercase text-emerald-400">Univers Services · HB Services</span>
          </div>

          <h1 className="text-5xl md:text-6xl font-bold tracking-tight text-white mb-6 leading-tight">
            Propreté impeccable,<br />
            <span className="text-emerald-400">service irréprochable</span>
          </h1>
          <p className="text-lg text-white/75 leading-relaxed mb-10 max-w-xl">
            Nettoyage professionnel pour particuliers, entreprises et immeubles à Genève. Équipes certifiées, produits écologiques, résultats garantis.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <a href="#tarifs" className="inline-flex items-center justify-center gap-2 rounded-lg bg-emerald-500 px-7 py-3.5 text-sm font-semibold text-white hover:bg-emerald-600 transition-all whitespace-nowrap cursor-pointer">
              <i className="ri-price-tag-3-line"></i>
              Voir les tarifs
            </a>
            <a href="#contact-nettoyage" className="inline-flex items-center justify-center gap-2 rounded-lg bg-white/10 backdrop-blur-sm px-7 py-3.5 text-sm font-semibold text-white border border-white/25 hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer">
              <i className="ri-mail-send-line"></i>
              Devis gratuit
            </a>
          </div>

          {/* Stats */}
          <div className="mt-14 flex flex-wrap gap-8">
            {[
              { value: '500+', label: 'Clients satisfaits' },
              { value: '7j/7', label: 'Disponibilité' },
              { value: '100%', label: 'Produits éco' },
            ].map((stat, i) => (
              <div key={i}>
                <div className="text-2xl font-bold text-white">{stat.value}</div>
                <div className="text-xs text-white/50 mt-0.5">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Badges flottants */}
      <div className="absolute bottom-8 right-8 hidden lg:flex flex-col gap-3">
        {[
          { icon: 'ri-shield-check-line', text: 'Équipes certifiées' },
          { icon: 'ri-leaf-line', text: 'Produits écologiques' },
          { icon: 'ri-time-line', text: 'Flexibilité 7j/7' },
        ].map((b, i) => (
          <div key={i} className="flex items-center gap-2.5 bg-white/10 backdrop-blur-md border border-white/20 rounded-lg px-4 py-2.5">
            <i className={`${b.icon} text-emerald-400 text-sm`}></i>
            <span className="text-xs font-medium text-white">{b.text}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
